import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import theme from './theme/theme';

import 'nprogress/nprogress.css';
import App from 'src/App';
// import { SidebarProvider } from 'src/contexts/SidebarContext';
import * as serviceWorker from 'src/serviceWorker';
import 'sweetalert2/dist/sweetalert2.min.css';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

NotificationContainer.defaultProps = {
  position: 'top-right' // or 'bottom-right' or 'top-left' or 'bottom-left'
};

ReactDOM.render(
  <HelmetProvider>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* Push toasts below the sticky navbar (64px desktop / 56px mobile Toolbar height)
          so they don't render on top of the avatar/menu in the top-right corner. */}
      <GlobalStyles
        styles={{
          '.notification-container': {
            top: '76px',
          },
          '@media (max-width: 599.95px)': {
            '.notification-container': {
              top: '68px',
            },
          },
        }}
      />
      <BrowserRouter>
        <App />
        <NotificationContainer />
      </BrowserRouter>
    </ThemeProvider>
  </HelmetProvider>,
  document.getElementById('root')
);

serviceWorker.unregister();
